import { Dispatch, SetStateAction, createContext, useState } from "react";

interface AddressFormData {
  address: string;
  addressNumber: string;
  addressDetail: string;
  postalCode: string;
  city: string;
  province: string;
  district?: string;
}

interface PhoneFormData {
  phoneNumber: string;
  countryCode: string;
}

const phoneFormDataInitialValue = {
  phoneNumber: "",
  countryCode: "",
};

const addressFormDataInitialValue = {
  address: "",
  addressNumber: "",
  addressDetail: "",
  postalCode: "",
  city: "",
  province: "",
};

interface AppContextType {
  addressFormData: AddressFormData;
  setAddressFormData: Dispatch<SetStateAction<AddressFormData>>;
  isFilledAddressFormData: () => boolean;
  isFilledPhoneFormData: () => boolean;
  setPhoneFormData: Dispatch<SetStateAction<PhoneFormData>>;
  phoneFormData: PhoneFormData;
}

const initialAppContext = {
  addressFormData: addressFormDataInitialValue as AddressFormData,
  setAddressFormData: () => null,
  isFilledAddressFormData: () => false,
  isFilledPhoneFormData: () => false,
  setPhoneFormData: () => null,
  phoneFormData: phoneFormDataInitialValue,
};

const RequestCardContext = createContext<AppContextType>(initialAppContext);

const RequestCardProvider = ({ children }: { children: JSX.Element }) => {
  const [addressFormData, setAddressFormData] = useState<AddressFormData>(
    addressFormDataInitialValue
  );
  const [phoneFormData, setPhoneFormData] = useState<PhoneFormData>(
    phoneFormDataInitialValue
  );

  const isFilledAddressFormData = () => {
    const { addressDetail, ...addressFormDataWithoutDetail } = addressFormData;
    return Object.values(addressFormDataWithoutDetail).every(
      (value) => value !== ""
    );
  };

  const isFilledPhoneFormData = () => {
    return Object.values(phoneFormData).every((value) => value !== "");
  };

  return (
    <RequestCardContext.Provider
      value={{
        addressFormData,
        setAddressFormData,
        isFilledAddressFormData,
        isFilledPhoneFormData,
        setPhoneFormData,
        phoneFormData,
      }}
    >
      {children}
    </RequestCardContext.Provider>
  );
};

export { RequestCardProvider, RequestCardContext };
